package de.oevbs.kunde.kundenportal2.model.services.lifeValueNotification

import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse

abstract class LifeValueClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

    override val requestTimeoutMillis: Long = 30000L

    /**
     * Läd die Leben-Vertragsdaten des eingeloggten Users/Partners, für die eine Wertstands-
     * mitteilung erstellt werden kann.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun init(): ClientResponse<LifeValueNotification> =
        get("/lifevalue/init")


    /**
     * Erstellt Workitem und Kontakt für den ausgewählten Leben-Vertrag für den Kundenservice, so dass eine Wert-
     * standsmitteilung per Post an den Kunden versendet wird.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun requestNotifications(selectedContracts: List<LifeContract>): ClientResponse<Unit> =
        post("/lifevalue/create", selectedContracts)

}